import React from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Button from '../../stories/general-components/Button';
import BuildIcon from '@mui/icons-material/Build';
import { useTranslation } from 'react-i18next';
const HeaderPage = ({
  caption,
  title,
  subtitle
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#bc0c0c',
        py: 10,
        mb: 8,
        position: 'relative',
        minHeight: '360px',
        overflow: 'hidden',
      }}
    >
      <BuildIcon
        sx={{
          position: 'absolute',
          right: '-5%',
          top: '50%',
          transform: 'translateY(-50%)',
          fontSize: '400px',
          color: 'rgba(255, 255, 255, 0.05)',
          zIndex: 0,
        }}
      />
      <Container maxWidth="lg" sx={{ maxWidth: '1200px !important', position: 'relative', zIndex: 1 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            alignItems: 'center',
            textAlign: 'center',
          }}
        >


          {title && (
            <Typography
              variant="h3"
              sx={{
                color: 'white !important',
                fontWeight: 700,
              }}
            >
              {title}
            </Typography>
          )}

          {subtitle && (
            <Typography
              variant="h5"
              sx={{
                color: 'white !important',
                fontWeight: 400,
              }}
            >
              {subtitle}
            </Typography>
          )}
          {caption && (
            <Typography
              variant="body2"
              sx={{
                color: 'white !important',
                fontWeight: 400,
                fontSize: '0.9rem',
                maxWidth: '400px',
              }}
            >
              {caption}
            </Typography>
          )}
          <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 2,
            mt: 2,
          }}>

            <Button
              buttonSx={{
                backgroundColor: '#000000',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#000000',
                },
              }}
              label={t('membership')}
              onClick={
                () => {
                  navigate('/use-cases');
                }
              }
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HeaderPage;
